"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
function stripUnit(value, unitReturn) {
    if (typeof value !== 'string') {
        return value;
    }
    var matchedValue = value.match(cssRegex);
    if (unitReturn) {
        if (matchedValue)
            return [parseFloat(value), matchedValue[2]];
        return [value, undefined];
    }
    if (matchedValue)
        return parseFloat(value);
    return value;
}
exports.default = stripUnit;
//# sourceMappingURL=stripUnit.js.map